<template>
  <div class="">
    <policy-create />
  </div>
</template>

<script>
import PolicyCreate from "@/components/wallet/policies/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    PolicyCreate,
  },
  created() {
    this.notifyQueue({
      text: "Crea Polizza",
      path: "insurance_policies.create",
      level: 4,
    });
  },
};
</script>
